import { render, staticRenderFns } from "./acceptTerm.vue?vue&type=template&id=cbee1f84&scoped=true"
import script from "./acceptTerm.vue?vue&type=script&lang=js"
export * from "./acceptTerm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbee1f84",
  null
  
)

export default component.exports